<template>
  <div class="icon">
    <!--Success Icon -->
    <div
      v-if="type == 'success'"
      class="icon-success"
    >
      <div class="icon-success-tip" />
      <div class="icon-success-long" />
      <div class="icon-success-placeholder" />
      <div class="icon-success-fix" />
    </div>

    <!--Warning Icon-->
    <div
      v-else-if="type == 'warning'"
      class="icon-warning"
    >
      <div class="icon-warning-body" />
      <div class="icon-warning-dot" />
    </div>

    <div
      v-else-if="type == 'loading'"
    >
      <b-spinner
        class="mr-1"
        variant="primary"
        style="width: 3rem; height: 3rem;"
      />
    </div>

    <!-- Danger Icon-->
    <div
      v-else
      class="icon-error"
    >
      <div class="icon-error-x">
        <div class="icon-error-left" />
        <div class="icon-error-right" />
      </div>
      <div class="icon-error-placeholder" />
      <div class="icon-error-fix" />
    </div>
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'

export default {
  components: { BSpinner },
  props: ['type'],
}
</script>

<style scoped lang="scss">
    @import '~@core/scss/vue/apps/icons-animation.scss';
    @import '~@core/scss/vue/apps/loading.scss';
</style>
